import { isMainnet } from 'config'
import { Ether } from 'types'

// ---------- Range of mapping token id ----------
export const MAPPING_TOKEN_BEGIN = 2
export const MAPPING_TOKEN_END = 16

// ---------- Range of stable token id ----------
export const STABLE_TOKEN_BEGIN = 17
export const STABLE_TOKEN_END = 31

// ---------- USD token info ----------
export const PRIMARY_CURRENCY =
  process.env.REACT_APP_PRIMARY_CURRENCY! ?? 'USDT'
export const PRIMARY_CURRENCY_PRICE = '1'
export const PRIMARY_CURRENCY_DECIMALS = 2

// ---------- Max amount for deposit and withdraw ----------
export const MAX_DEPOSIT_CURRENCY_QUANTITY: Ether = '1000000000000000000' // Math.pow(10, 18)

// Currency color on portfolio page
export const CurrencyBackgroundColor: { [index: string]: string } = {
  wBTC: '#F7931A',
  USD: '#8CE346',
  wETH: '#627EEA',
  wMATIC: '#8247E5',
  wAVAX: '#E84142',
  QUICK: '#2C3978',
  JOE: '#F4716B',
}

export const CurrencySymbolMapping = {
  ETH: isMainnet ? 'ETH' : 'wETH',
  AVAX: isMainnet ? 'AVAX' : 'wAVAX',
  MATIC: isMainnet ? 'MATIC' : 'wMATIC',
}

// ---------- block tokens for useTokenList ----------
export const BLOCK_TOKENS: string[] = []

export const ASSETS_QUOTE_SYMBOL = process.env.REACT_APP_ASSETS_QUOTE_SYMBOL!
